import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { SortFilterObject } from 'app/model/entity/sort-filter-object';
import { AppState } from 'app/store/app.state';

@Injectable({
  providedIn: 'root'
})
export class SortFilterUserManagerService {
  /**
   * Sort filter
   */
  private sortFilterUser: SortFilterObject;
  constructor(public readonly store: Store<AppState>) {
    this.store
      .select(state => state)
      .subscribe((componentState: any) => {
        this.sortFilterUser = componentState?.sortFilterUserManagerState?.stateOfComponent?.sortFilterUser ?? new SortFilterObject();
      });
  }

  /**
   * Get sort filter object
   *
   * @returns
   */
  public getSortFilterObject(): SortFilterObject {
    return this.sortFilterUser;
  }
}
